import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "@shared/shared.module";
import { ContactComponent } from "@shared/pages/contact/contact.component";

const matImportedModules = [MatMenuModule, MatDialogModule, MatButtonModule, MatInputModule];

@NgModule({
  declarations: [AppComponent, ContactComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: "wash-app" }),
    BrowserAnimationsModule,
    AppRoutingModule,
    ...matImportedModules,
    SharedModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
